import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function GiveSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "polling", data: null });

  useEffect(() => {
    if (!sessionId) { setState({ status: "error", data: null }); return; }
    let cancelled = false;
    let attempts = 0;
    const maxAttempts = 8;

    const poll = async () => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/donations/status/${sessionId}`);
        if (data.payment_status === "paid") { setState({ status: "success", data }); return; }
        if (data.status === "expired") { setState({ status: "expired", data }); return; }
        attempts += 1;
        if (attempts >= maxAttempts) { setState({ status: "timeout", data }); return; }
        setTimeout(poll, 2000);
      } catch {
        attempts += 1;
        if (attempts >= maxAttempts) { setState({ status: "error", data: null }); return; }
        setTimeout(poll, 2500);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="give-success-page">
      <div className="max-w-lg w-full border hairline rounded-2xl p-10 surface text-center">
        {state.status === "polling" && (
          <>
            <Loader2 className="w-14 h-14 text-gold mx-auto animate-spin" />
            <h1 className="mt-6 font-display text-3xl text-white">Confirming your gift…</h1>
            <p className="mt-3 text-zinc-400">This will only take a moment.</p>
          </>
        )}
        {state.status === "success" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-gold mx-auto" data-testid="give-success-check" />
            <h1 className="mt-6 font-display text-3xl text-white">Thank you!</h1>
            <p className="mt-3 text-zinc-300">Your gift of <span className="text-gold font-semibold">${(state.data.amount_total / 100).toFixed(2)}</span> has been received. May the Most High bless your generosity.</p>
            <Link to="/" className="mt-8 inline-flex px-6 py-3 rounded-full bg-gold text-black font-semibold hover:bg-slate-200 transition-colors duration-200">Return Home</Link>
          </>
        )}
        {(state.status === "expired" || state.status === "timeout" || state.status === "error") && (
          <>
            <XCircle className="w-14 h-14 text-red-500 mx-auto" />
            <h1 className="mt-6 font-display text-3xl text-white">We couldn't confirm the payment</h1>
            <p className="mt-3 text-zinc-400">If you were charged, please contact us and we'll help right away.</p>
            <Link to="/give" className="mt-8 inline-flex px-6 py-3 rounded-full border border-white/20 text-white hover:border-gold hover:text-gold">Try Again</Link>
          </>
        )}
      </div>
    </div>
  );
}
